import { Pipe, PipeTransform } from '@angular/core';
import { DecimalPipe } from '@angular/common';
import { kmToMiles, milesToKm } from '../lib/utils';
import { getLocale } from '../lib/i18n';

type unit = 'mile' | 'km';

@Pipe({ name: 'distance' })
export class DistancePipe implements PipeTransform {

  constructor(private decimalPipe: DecimalPipe) {}

  public transform(distance, isMetricUnits?: boolean, doRound = true, format: string = '1.0-1', currentUnit: unit = 'km') {
    if (distance == null) return;
    if (isMetricUnits && currentUnit === 'mile') distance = milesToKm(distance);
    if (!isMetricUnits && (!currentUnit || currentUnit === 'km')) distance = kmToMiles(distance);
    return doRound ? this.decimalPipe.transform(distance, format, getLocale()) : distance;
  }
}
